import { createSlice } from "@reduxjs/toolkit";

export interface ISharedDialogState {
    open: boolean;
}

export const sharedDialogInitialState: ISharedDialogState = {
    open: false
};

export const SharedDialogSlice = createSlice({
    name: "sharedDialog",
    initialState: sharedDialogInitialState,
    reducers: {
      openDialog: () => ({
        open: true
      }),
      closeDialog: () => ({
        open: false
      })
    }
});

export const SharedDialogActions = SharedDialogSlice.actions;
export const SharedDialogReducer = SharedDialogSlice.reducer;